/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) System Send Kudos Icon component.
 */
export const SystemSendKudosIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_14304_22685)'>
        <path d='M7.05471 7.70508H2V19.3471H7.05471V7.70508Z' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M13.1572 7.69085L14.2047 4.87877C14.3242 4.55539 14.268 4.01406 13.7126 4C13.2598 4.02852 12.8206 4.16618 12.4325 4.40122C12.0445 4.63626 11.719 4.96173 11.484 5.34981L9.7124 7.66976V19.375H16.5528C17.5033 19.3761 18.4246 19.0463 19.1584 18.442C19.8922 17.8378 20.3928 16.9969 20.5741 16.0638L21.9801 8.92114C22.0102 8.76934 22.0063 8.61275 21.9687 8.46263C21.9311 8.31252 21.8607 8.17262 21.7625 8.05296C21.6644 7.93331 21.5409 7.83688 21.4011 7.77062C21.2612 7.70436 21.1084 7.66992 20.9537 7.66976L13.1572 7.69085Z' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      </g>
      <defs>
        <clipPath id='clip0_14304_22685'>
          <rect width={iconSize} height={iconSize} fill={dlsColor('white')} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SystemSendKudosIcon;
